import { actions as investment } from '@/plugins/Investment'

const getters = {
  projectType (state) {
    return investment.getProjectType(state.investments.entity)
  },

  securityType (state) {
    return investment.getSecurityType(state.investments.entity)
  },

  termRemaining (state) {
    return investment.termRemaining(state.investments.entity)
  }
}

export default getters
